import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AnimatedSpinner, Box, Container, Flex } from '@tq/ui-components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';

import { useConsultation } from 'api';
import { AssigneeDetails, AssignModal } from 'components';
import { useAssignModal, useNavigate } from 'hooks';
import { HttpError } from 'types';
import {
  RequestExtensionModal,
  SummaryHeader,
  DesktopSummary,
  MobileSummary,
} from './components';

export const ConsultationSummary: React.FC = () => {
  const { id } = useParams();
  const isMobile = useIsMobile();
  const {
    data: consultation,
    error,
    isError,
    isLoading,
    isLoadingError,
    isRefetchError,
  } = useConsultation(+(id ?? 0));
  const { showAssignModal, handleClose } = useAssignModal();
  const { navigateToErrorPage } = useNavigate();

  const [showSpinner, setShowSpinner] = useState(true);
  useEffect(() => {
    setShowSpinner(isLoading || isLoadingError || isRefetchError);
  }, [isLoading, isLoadingError, isRefetchError]);

  useEffect(() => {
    if (isError && error) {
      navigateToErrorPage(error as HttpError);
    }
  }, [isError, error, navigateToErrorPage]);

  return showSpinner ? (
    <Flex justifyContent='center'>
      <AnimatedSpinner size='lg' />
    </Flex>
  ) : (
    <Container mb={12} px={{ base: 0, lg: 4, xl: 0 }}>
      <Box my={9}>
        <SummaryHeader />
        <AssigneeDetails showFooter={false} />
      </Box>
      {isMobile ? (
        <MobileSummary consultation={consultation} isLoading={isLoading} />
      ) : (
        <DesktopSummary consultation={consultation} isLoading={isLoading} />
      )}
      <AssignModal isOpen={showAssignModal} onClose={handleClose} />
      {consultation && <RequestExtensionModal consultationId={consultation.id} />}
    </Container>
  );
};
